import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class DatePickerService {

    formatDate(format: string, date: Date) {
        let formattedDate: string;
        let calendarStart: Date;
        if (format === 'mm/dd/yyyy') {
            formattedDate = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
        }else if(format === 'yyyy-mm-dd'){
            formattedDate = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2); 
        };
        return formattedDate;
    }

    getSelectedMonth(direction: number, previousMonth: number, previousYear: number) {
        let selectedMonth = previousMonth + direction;
        let selectedYear = previousYear;

        selectedMonth = selectedMonth > 11 ? 0 : (selectedMonth < 0 ? 11 : selectedMonth);
        if (direction > 0 && selectedMonth === 0) {
            selectedYear = previousYear + direction;
        } else if (direction < 0 && selectedMonth === 11) {
            selectedYear = previousYear + direction;
        };

        return [selectedMonth, selectedYear];
    }

    getStartDate(forMonth: number, forYear: number) {
        let calendarStart = new Date(forYear, forMonth, 1);
        const firstDay = calendarStart.getDay();
        if (firstDay > 0) {
            calendarStart = new Date(forYear, forMonth, -firstDay + 1)
        }
        return calendarStart;
    }

    getCalendarDates(startDate: Date, n: number, selectedDate: Date) {
        let dates: Array<Date> = new Array();
        const current = new Date(startDate.getTime());
        let i = 0;
        while (i < n) {
            if (this.dateComparator(current, selectedDate) === 0) {
                var selectedRowIndex = Math.floor(i / 7);
                var selectedDateIndex = i % 7;
            }
            dates.push(new Date(current.getTime()));
            current.setDate(current.getDate() + 1);
            i++;
        }
        return { 'datesArray': dates, 'selectedRowIndex': selectedRowIndex, 'selectedDateIndex': selectedDateIndex };
    }

    createDateObject(calendarDates: Array<Date>, forMonth: number, minDate: Date, maxDate: Date) {
        let calendarDatesObj: Array<any> = [];
        calendarDates.forEach(date => {
            let dateObject: any = {};
            dateObject.date = date;
            dateObject.label = date.getDate();
            dateObject.selected = false;
            ({ 'disabled': dateObject.disabled, 'secondary': dateObject.secondary } = this.isDisabled(date, forMonth, minDate, maxDate));
            dateObject.current = this.dateComparator(date, new Date()) === 0;
            calendarDatesObj.push(dateObject);
        });
        return calendarDatesObj;
    }

    isDisabled(date: Date, forMonth: number, minDate: Date, maxDate: Date) {
        let disabled;
        if (date.getMonth() === forMonth) {
            const minDateComparator = minDate ? this.dateComparator(date, minDate) : 1;
            const maxDateComparator = maxDate ? this.dateComparator(maxDate, date) : 1;
            disabled = minDateComparator >= 0 && maxDateComparator >= 0 ? false : true;
            return { disabled: disabled, secondary: false };
        }
        return { disabled: true, secondary: true };
    }

    private dateComparator(date1: Date, date2: Date) {
        const d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
        const d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
        return d1.getTime() - d2.getTime();
    };

    formCalendarView(calendarDatesObject: Array<any>, forMonth: number) {
        let rows = new Array();
        for (let i = 0; i < 6; i++) {
            if (calendarDatesObject[0].date.getMonth() === forMonth || 
            calendarDatesObject[6].date.getMonth() === forMonth) {
                rows[i] = calendarDatesObject.splice(0, 7);
            }
        }
        return rows;
    }

    checkNavigation(calendarDates: Array<Date>, minDate: Date, maxDate: Date) {
        var length = calendarDates.length - 1;
        var disableDown = this.dateComparator(calendarDates[0], minDate) < 0 ? true : false;
        var disableUp = this.dateComparator(maxDate, calendarDates[length - 1]) < 0 ? true : false;
        return [disableDown, disableUp];
    }

    getFocusableElements(el1, el2) {
        return Array.prototype.slice.call(el1
        .querySelectorAll(el2)[0]
        .querySelectorAll('a[href], area[href],' +
        ' input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]'));
    }
}
